const TOKEN_KEY = "hei_admin_token";

function apiBase() {
    return String(process.env.REACT_APP_DELIVERY_API_URL || "").replace(/\/+$/, "");
}

export function getRetouchAdminToken() {
    try {
        return localStorage.getItem(TOKEN_KEY) || "";
    } catch {
        return "";
    }
}

export function clearRetouchAdminToken() {
    try {
        localStorage.removeItem(TOKEN_KEY);
    } catch {
        // ignore
    }
}

export async function verifyRetouchAdminToken(token) {
    if (!apiBase() || !token) return false;
    try {
        const response = await fetch(`${apiBase()}/auth/verify`, { headers: { Authorization: `Bearer ${token}` } });
        const body = await response.json().catch(() => ({}));
        return response.ok && Boolean(body.ok);
    } catch {
        return false;
    }
}
